var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.794,
    height: 28.794,
    viewBox: "0 0 28.794 28.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1355",
    "data-name": "Group 1355",
    transform: "translate(0.311 0.311)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_707",
    "data-name": "Group 707"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_872",
    "data-name": "Path 872",
    d: "M4.286,9.355,0,5.953,5.092,7.962c7.612,3,8.639,2.73,13.729-3.679L22.223,0l-2.01,5.087c-3,7.613-2.73,8.639,3.68,13.73l4.282,3.4L23.088,20.21C15.476,17.2,14.449,17.479,9.359,23.89l-3.4,4.282,2.01-5.087C10.971,15.472,10.7,14.445,4.286,9.355Zm6.644,10.2c1.9-1.953,3.477-2.822,5.518-2.822a11.6,11.6,0,0,1,3.114.509c-2.831-2.759-3.386-4.828-2.313-8.633C14.49,11.444,12.422,12,8.617,10.926,11.448,13.685,12,15.754,10.93,19.559Z",
    transform: "translate(-0.004)",
    fill: "#616161",
    stroke: "#707070",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.1235ac570b5364da4327768f394a96ad.svg";
export { ForwardRef as ReactComponent };